import Swiper, { Navigation, Lazy, Autoplay } from 'swiper';

Swiper.use([Navigation, Lazy, Autoplay]);

const els = document.querySelectorAll('[data-js=leadcards]');
for (let i = els.length - 1; i >= 0; i -= 1) {
	const sliderEl = els[i].querySelector('[data-js=leadcards-carousel]');
	const timeOuts = {
		sm: Number(sliderEl.getAttribute('data-js-timeout-xs')),
		md: Number(sliderEl.getAttribute('data-js-timeout-md')),
		lg: Number(sliderEl.getAttribute('data-js-timeout-lg')),
	};

	const setSize = (swiper, delay = 0) => {
		const headings = [];
		let height = 0;

		swiper?.slides.forEach((e) => {
			const heading = e.querySelectorAll('[data-js=leadcards-heading]');
			headings.push(heading);
		});

		setTimeout(() => {
			headings.forEach((e) => {
				height = e[0].clientHeight > height ? e[0].clientHeight : height;
			});

			headings.forEach((e) => {
				e[0].style.height = `${height}px`;
			});
		}, delay);
	};

	// eslint-disable-next-line no-new
	new Swiper(sliderEl, {
		allowTouchMove: false,
		loop: true,
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 10,
		speed: timeOuts.sm,
		breakpoints: {
			450: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 10,
				speed: timeOuts.sm,
			},
			768: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 15,
				speed: timeOuts.md,
			},
			1000: {
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 20,
				speed: timeOuts.md,
			},
			1200: {
				slidesPerView: 5,
				slidesPerGroup: 5,
				spaceBetween: 25,
				speed: timeOuts.lg,
			},
			1600: {
				slidesPerView: 6,
				slidesPerGroup: 6,
				spaceBetween: 25,
				speed: timeOuts.lg,
			},
			1800: {
				slidesPerView: 7,
				slidesPerGroup: 7,
				spaceBetween: 30,
				speed: timeOuts.lg,
			},
		},
		lazy: { checkInView: true, loadPrevNext: true },
		preloadImages: true,
		on: {
			slideChangeTransitionStart: (swiper) => setSize(swiper),
			resize: (swiper) => setSize(swiper),
		},
		autoplay: {
			delay: 1,
			disableOnInteraction: false,
			// pauseOnMouseEnter: true,
		},
	});
}
